import { Head } from "@inertiajs/react";
import { useTranslation } from "react-i18next";

import { PasswordForm } from "@/components/settings/password-form";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import SettingsLayout from "@/layouts/settings_layout";

export default function PasswordSettings() {
  const { t } = useTranslation();
  return (
    <SettingsLayout>
      <Head title={t("common.password")} />
      <h1 className="text-page font-display">{t("common.password")}</h1>
      <Card data-layout-frame="">
        <CardHeader>
          <CardTitle>{t("common.password")}</CardTitle>
        </CardHeader>
        <CardContent>
          <PasswordForm />
        </CardContent>
      </Card>
    </SettingsLayout>
  );
}
